module.exports = __webpack_public_path__ + "fonts/6d906abe5bff3c8db464fe6f09ca996f.svg";